import React from 'react'
import Navbar from '../../Components/Navbar'

function Books() {
    return (
        <div>
            <Navbar/>
            <h1>No Books Available.</h1>
        </div>
    )
}

export default Books
